<template>
  <div>
    <Header
      :title="$t('presets.presets').toString()"
      :items="headerButtons"
      @create-preset="$router.push({ name: 'projectSettingsPresetsCreate' })"
    />
    <TableHelper
      ref="table"
      :items="presets"
      :meta="meta"
      :fields="fields"
      :actions="actions"
      :enable-filter="false"
      loading-key="loadSettingsPresets"
      @reload-data="loadPresets"
      @edit="editPreset"
      @delete="deletePreset"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TableHelper from "@/components/Tools/TableHelper/TableHelper.vue";
import Header from "@/components/Tools/Header/Header.vue";
import {
  addEventToLoadingQueue,
  removeEventFromLoadingQueue
} from "@/composables/useLoadingQueue";
import Presets from "@/components/Settings/Presets/presets";
import Swal from "sweetalert2";
import { useCurrentProjectFilter } from "@/composables/useCurrentProjectFilter";

export default {
  name: "ProjectsSettingsConfigTable",
  components: {
    Header,
    TableHelper
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: this.$t("presets.name"),
          sortable: true,
          thStyle: { width: "200px" }
        },
        {
          key: "label",
          label: this.$t("presets.label"),
          sortable: true,
          thStyle: { width: "200px" }
        },
        {
          key: "type",
          label: this.$t("presets.type"),
          sortable: true,
          thStyle: { width: "100px" }
        },
        {
          key: "value",
          label: this.$t("presets.value"),
          sortable: true,
          thStyle: { width: "500px" }
        }
      ],
      presets: [],
      searchTitle: "",
      // Meta info
      meta: {}
    };
  },
  computed: {
    ...mapGetters("route", ["requestParams"]),
    ...mapGetters([
      "selectedProject",
      "selectedPresetVersion",
      "isDevPresetVersion"
    ]),
    headerButtons: function () {
      if (!this.isDevPresetVersion) {
        return [];
      }
      return [
        {
          type: "button",
          title: this.$t("presets.presetCreate"),
          icon: "fa-light fa-plus",
          emit: "create-preset"
        }
      ];
    },
    actions: function () {
      const actions = [
        {
          key: "edit",
          icon: "fal fa-pen",
          emit: "edit",
          tooltip: this.$t("general.edit")
        }
      ];
      if (this.isDevPresetVersion) {
        actions.push({
          key: "delete",
          icon: "fal fa-trash",
          emit: "delete",
          tooltip: this.$t("general.delete")
        });
      }
      return actions;
    }
  },
  watch: {
    selectedProject: function () {
      this.loadPresets();
    },
    selectedPresetVersion: function () {
      this.loadPresets();
    }
  },
  mounted() {
    this.loadPresets();
  },
  methods: {
    loadPresets(payload = {}) {
      addEventToLoadingQueue({ key: "loadSettingsPresets" });

      let params = { ...this.requestParams(), ...payload };
      const { filter } = useCurrentProjectFilter();

      Presets.getAll(params, filter.value)
        .then(response => {
          this.presets = response.data;
          this.meta = response.meta;
          removeEventFromLoadingQueue({ key: "loadSettingsPresets" });
        })
        .catch(error => {
          this.$error(error);
        });
    },
    editPreset(item) {
      this.$router.push({
        name: "projectSettingsPresetsEdit",
        params: { presetId: item.item.id }
      });
    },
    deletePreset(item) {
      Swal.fire({
        title: this.$t("presets.presetDeleteTitle"),
        text: this.$t("presets.presetDeleteMessage", {
          preset: item.item.name
        }),
        icon: "warning",
        showConfirmButton: true,
        confirmButtonText: this.$t("general.delete"),
        confirmButtonColor: "var(--primary)",
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: this.$t("general.cancel")
      }).then(result => {
        if (result.isConfirmed) {
          addEventToLoadingQueue({ key: "deleteSettingsPreset" });

          Presets.delete(item.item.id)
            .then(() => {
              removeEventFromLoadingQueue({
                key: "deleteSettingsPreset",
                type: "success",
                prefix: "presets",
                name: "presetDeleted"
              });

              this.loadPresets();
            })
            .catch(error => {
              this.$error(error);
            });
        }
      });
    }
  }
};
</script>
